"use client";

import { usePathname, useRouter, useSearchParams } from "next/navigation";

import { TablesList, TableSource } from "@/components/TableTool/TablesList";

export default function TablesWorkshop() {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const source: TableSource =
    searchParams?.get("source") === "platform" ? "platform" : "custom";

  const setSource = (next: TableSource) => {
    const params = new URLSearchParams(window.location.search);
    if (next === "platform") params.set("source", next);
    else params.delete("source");
    router.replace(`${pathname ?? "/"}?${params.toString()}`, {
      scroll: false,
    });
  };

  return (
    <div className="flex w-full flex-1 flex-col pb-5">
      <TablesList source={source} onSourceChange={setSource} />
    </div>
  );
}
